import { EnrichedSwarovskiProductFrontendProductReview } from "@swo/storefront";

export const reviewsFilter =
  (reviews: Array<EnrichedSwarovskiProductFrontendProductReview>) =>
  (filter: { starsFilter: number | null; showCountLimit: number }) => {
    const starFilteredReviews =
      filter.starsFilter !== null ? reviews.filter(r => Math.floor(r.rating) === filter.starsFilter) : reviews;

    return {
      filtered: starFilteredReviews.slice(0, filter.showCountLimit),
      hasMore: starFilteredReviews.length > filter.showCountLimit,
    };
  };
